export default "__VITE_ASSET__C5Mi8d4L__"